import * as React from "react"
import 'intersection-observer';
import { InView } from 'react-intersection-observer';
import { Action, IOWidget, mk_widget, Pair } from "widgets-for-react"
import { Id, CMSState, ImageSize, Url } from "../../../../cms/blocks/types.gen";
import { link, getClassName } from "../../../../cms/blocks/utils.gen"
import { ImageContainer } from "../../../../cms/blocks/widgets/ImageContainer.gen";
import { blockInviewHandler } from "../../../utils/inview_utils";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { WordPress } from "../../../../wordpress/wordpress_api";
import { toRelativeUrl } from "../../../../../helpers";
import { getImageAttribute } from "../../../utils/extra_images.mod";

export type AttentionAttributes = {
    blockName: 'vidda/attention'
    title: string
    image?: WordPress.MediaResponse
}

export interface AttentionInterface {
    blockName: 'vidda/attention'
    attrs: AttentionAttributes
}

export type AttentionBlockProps<extra_iamges> = AttentionAttributes

export type AttentionBlockStyle = Partial<{
  block_contentwidth_classname: string
  block_fullwidth_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  visual_classname: string
  image_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function AttentionBlock<customBlockData, extra_images>(
  props: AttentionBlockProps<extra_images>,
  options?: { style?: AttentionBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<customBlockData, extra_images, never>>> {
  return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => (
        <div>
          {props.title && <h1 className="attention__title">{props.title}</h1>}
          {props.image && props.image.media_details && (
            <div className="attention__visual">
              <img
                src={getImageAttribute(props.image, 'attention', 'source_url')}
                width={getImageAttribute(props.image, 'attention', 'width')}
                height={getImageAttribute(props.image, 'attention', 'height')}
                className="attention__image"
                alt={props.image.alt_text ? props.image.alt_text : ''}
              />
            </div>
          )}
        </div>
      ),
    })
}
